import React, {useEffect} from "react";
import Sidebar from "../../components/SideBar";
import Navbar from "../../components/NavBar";
import {useNavigate} from "react-router-dom";

const NoMatch = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (window.localStorage.getItem("auth_token") === null) navigate("/login");
    }, [navigate]);
    const token = window.localStorage.getItem("auth_token");

  return (
      <>
          {token && (<div className="d-flex">
              <div>
                  <Sidebar/>
              </div>

              <div
                  style={{
                      flex: "1 1 auto",
                      display: "flex",
                      flexFlow: "column",
                      height: "100vh",
                      overflowY: "hidden",
                  }}
              >
                  <Navbar/>
                  <div style={{height: "100%"}}>
                      <div
                          style={{
                              padding: "20px 5%",
                              height: "calc(100% - 64px)",
                              overflowY: "scroll",
                          }}
                      >
                          <p>no match</p>
                      </div>
                  </div>
              </div>
          </div>)}
          {!token && <div className="login-container"></div>}
      </>

  );
};

export default NoMatch;
